const mock: boolean = false;
let _staticMode = false;

const getMockData = (functionName: string) => mockData.get(functionName);
const setMockData = (functionName: string, data: any) => { mockData.set(functionName, data); };
const setStaticMode = (v: boolean) => { _staticMode = v; };
/** 是否使用 mock 数据：Global.mock 或 staticMode 为 true 时使用 */
const isMockMode = () => mock || _staticMode;

const mockData = new Map<string, any>();

export const Global = {
    mock,
    getMockData,
    setMockData,
    setStaticMode,
    isMockMode,
}